import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import APIS from "@service/api";
import { getUser } from "@utils";

export const bonusManagementApi = createApi({
	reducerPath: "bonusManagementApi",
	refetchOnFocus: false,
	refetchOnReconnect: false,
	refetchOnMountOrArgChange: false,
	baseQuery: fetchBaseQuery({
		baseUrl: APIS["bonus-api"],
		prepareHeaders: (headers) => {
			const user = getUser();

			if (user?.token) {
				headers.set("Authorization", `Bearer=${user.token}`);
			}

			return headers;
		},
	}),
	endpoints: (builder) => ({
		startCashbackAdhocPreview: builder.mutation({
			query: () => ({
				url: "cashback/adhoc/preview",
				method: "POST",
				body: {},
			}),
		}),
		getCashbackAdhocPreviewResult: builder.query({
			query: (requestId) => ({
				url: `cashback/adhoc/preview/result/${encodeURIComponent(requestId)}`,
				method: "GET",
			}),
		}),
		startCashbackAdhocClaim: builder.mutation({
			query: ({ cashbackId }) => ({
				url: "cashback/adhoc/claim",
				method: "POST",
				body: { cashbackId },
			}),
		}),
		getCashbackAdhocClaimResult: builder.query({
			query: (requestId) => ({
				url: `cashback/adhoc/claim/result/${encodeURIComponent(requestId)}`,
				method: "GET",
			}),
		}),
	}),
});

export const {
	useStartCashbackAdhocPreviewMutation,
	useGetCashbackAdhocPreviewResultQuery,
	useStartCashbackAdhocClaimMutation,
	useGetCashbackAdhocClaimResultQuery,
} = bonusManagementApi;
